import React from "react";

export default function ClientDocuments(props) {

    return (
        <div className={'card'}>
            <div className="card-body">
                <h3 className={'m-b-0'}>Документы</h3>
            </div>
        </div>
    )

}